import { getPageBrands, getPageCurrency, getPageContent } from "./states";

export const services = {
  getPageBrands,
  getPageContent,
  getPageCurrency
};
